"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basicHoverEffectStyle = exports.clickBG = void 0;
exports.clickBG = {
    clickBG: {
        width: '100vw',
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        opacity: 0.6,
        zIndex: -100,
    }
};
exports.basicHoverEffectStyle = function (hoveredBGcolor) {
    if (hoveredBGcolor === void 0) { hoveredBGcolor = '#ddd'; }
    return ({
        transition: '0.2s',
        cursor: 'pointer',
        '&:hover': {
            transition: '0.2s',
            backgroundColor: hoveredBGcolor
        }
    });
};
